"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid/Grid"));
var Services = _interopRequireWildcard(require("../../services"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _NumberInput = _interopRequireDefault(require("../../components/TextFields/NumberInput"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _DateInput = _interopRequireDefault(require("../../components/TextFields/DateInput"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var nameMap = {
  criticalIllness: 'Critical Illness',
  criticalIllnessSpouse: 'Critical Illness (Spouse)',
  criticalIllnessChild: 'Critical Illness (Child))',
  deathDismemberment: 'Accidental Death and Dismemberment',
  dependentLife: 'Dependent Life',
  drugs: 'Drugs',
  employeeAssistance: 'Employee Assistance Program',
  medicalSecondOpinion: 'Medical Second Opinion',
  eldercare: 'Eldercare',
  lifeInsurance: 'Life Insurance',
  ltd: 'Long Term Disability',
  std: 'Short Term Disability',
  outOfProvince: 'Out of Province',
  stopLoss: 'Stop Loss',
  majorMedical: 'Major Medical',
  paramedicals: 'Paramedicals',
  eyeExams: 'Eye Exams',
  eyeGlassesAndContacts: 'Eye Glasses & Contacts',
  requiredMedicalEyewear: 'Medically Required Eyewear',
  basicDental: 'Basic Dental',
  majorDental: 'Major Dental',
  orthodontics: 'Orthodontics',
  virtualHealthcare: 'Virtual Healthcare'
};
var commissionMap = {
  criticalIllness: 'ci',
  criticalIllnessSpouse: 'ci',
  criticalIllnessChild: 'ci',
  deathDismemberment: 'add',
  dependentLife: 'depLife',
  drugs: 'health',
  employeeAssistance: 'efap',
  medicalSecondOpinion: 'efap',
  eldercare: 'efap',
  virtualHealthcare: 'virtualHealthcare',
  lifeInsurance: 'life',
  ltd: 'ltd',
  std: 'std',
  outOfProvince: 'outOfCountry',
  stopLoss: 'stopLoss',
  majorMedical: 'health',
  paramedicals: 'health',
  eyeExams: 'health',
  eyeGlassesAndContacts: 'health',
  requiredMedicalEyewear: 'health',
  basicDental: 'dental',
  majorDental: 'dental',
  orthodontics: 'dental'
};
var coverageKeyMap = {
  criticalIllness: 'criticalIllness',
  criticalIllnessSpouse: 'criticalIllness',
  criticalIllnessChild: 'criticalIllness',
  deathDismemberment: 'deathDismemberment',
  dependentLife: 'dependentLife',
  drugs: 'drugs',
  employeeAssistance: 'efap',
  medicalSecondOpinion: 'efap',
  eldercare: 'efap',
  virtualHealthcare: 'virtualHealthcare',
  lifeInsurance: 'lifeInsurance',
  ltd: 'ltd',
  std: 'std',
  outOfProvince: 'outOfCountry',
  stopLoss: 'stopLoss',
  majorMedical: 'healthcare',
  paramedicals: 'healthcare',
  eyeExams: 'healthcare',
  eyeGlassesAndContacts: 'healthcare',
  requiredMedicalEyewear: 'healthcare',
  basicDental: 'dental',
  majorDental: 'dental',
  orthodontics: 'dental'
};
var selectedKey = {
  criticalIllness: 'isSelected',
  criticalIllnessSpouse: 'includeSpouseCI',
  criticalIllnessChild: 'includeChildCI',
  deathDismemberment: 'isSelected',
  dependentLife: 'isSelected',
  drugs: 'isSelected',
  employeeAssistance: 'includeEmployeeAssistance',
  medicalSecondOpinion: 'includeMedicalSecondOpinion',
  eldercare: 'includeEldercare',
  virtualHealthcare: 'isSelected',
  lifeInsurance: 'isSelected',
  ltd: 'isSelected',
  std: 'isSelected',
  outOfProvince: 'isSelected',
  stopLoss: 'isSelected',
  majorMedical: 'isSelected',
  paramedicals: 'isSelected',
  eyeExams: 'includeEyeExams',
  eyeGlassesAndContacts: 'includeEyeGlassesAndContacts',
  requiredMedicalEyewear: 'includeRequiredSafetyEyeWear',
  basicDental: 'includeBasic',
  majorDental: 'includeMajor',
  orthodontics: 'includeOrthodontics'
};
var PricingDesignForm = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(PricingDesignForm, _PureComponent);
  function PricingDesignForm() {
    var _this;
    (0, _classCallCheck2["default"])(this, PricingDesignForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, PricingDesignForm, [].concat(args)), _this.state = {
      effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
      showEffectiveDateDialog: false,
      errors: {}
    }, _this._validateEffectiveDate = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var effectiveDateError, startOfMonth, effectiveDateUTC;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate);
          case 2:
            effectiveDateError = _context.sent;
            startOfMonth = dates.getStartOfMonth();
            effectiveDateUTC = dates.getUTC(_this.state.effectiveDate);
            if (effectiveDateUTC < startOfMonth) {
              effectiveDateError = 'Pricing can only be backed dated to the start of the month.';
            }
            _context.next = 8;
            return _this.setState({
              effectiveDateError: effectiveDateError
            });
          case 8:
            if (!effectiveDateError) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", false);
          case 10:
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._onBlur = function (markup, benefit, coverageType, key, value) {
      // don't allow changes when in revision view
      if (_this.props.revision) {
        return;
      }
      var data = (0, _defineProperty2["default"])({}, key, value);
      if (coverageType) {
        var netRateWithMarkup = value / (1 - markup / 100);
        var grossRate = netRateWithMarkup / (1 - _this.props.commissions[commissionMap[benefit]] / 100);
        var commissionRate = grossRate - netRateWithMarkup;
        data = {
          netRate: value,
          netRateWithMarkup: netRateWithMarkup,
          commissionRate: commissionRate,
          grossRate: grossRate
        };
      } else {
        coverageType = key; // set the coverage type to the key so we set the state correctly
      }
      _this.props.savePricingInput(_this.props.classID, _this.props.designID, benefit, coverageType, data);
    }, _this._setPastRate = function (benefit, coverageType, value) {
      // don't allow changes when in revision view
      if (_this.props.revision) {
        return;
      }
      _this.props.savePricingInput(_this.props.classID, _this.props.designID, benefit, coverageType, {
        pastRates: {
          grossRate: value
        }
      });
    }, _this._handleDropDownChange = function (benefit, key, value) {
      // don't allow changes when in revision view
      if (_this.props.revision) {
        return;
      }
      _this.props.savePricingInput(_this.props.classID, _this.props.designID, benefit, 'carrier', (0, _defineProperty2["default"])({}, key, value));
    }, _this._validateForm = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var isValid, planDesign, effectiveDateValid, promises;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            isValid = true;
            planDesign = _this.props.designs[_this.props.classID][_this.props.designID];
            _context3.next = 4;
            return _this._validateEffectiveDate();
          case 4:
            effectiveDateValid = _context3.sent;
            if (effectiveDateValid) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", null);
          case 7:
            promises = Object.keys(nameMap).map( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(key) {
                var coverage, markupError, soloNetRateError, duoNetRateError, familyNetRateError, carrierError;
                return _regenerator["default"].wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      coverage = planDesign[coverageKeyMap[key]];
                      if (!(coverage && (!coverage.isSelected || !coverage[selectedKey[key]]))) {
                        _context2.next = 3;
                        break;
                      }
                      return _context2.abrupt("return", null);
                    case 3:
                      _context2.next = 5;
                      return Services.validateInput('checkEmpty', "".concat(isNaN(_this.props.pricing[key].markup) ? '' : _this.props.pricing[key].markup));
                    case 5:
                      markupError = _context2.sent;
                      _context2.next = 8;
                      return Services.validateInput('checkEmpty', "".concat(isNaN(_this.props.pricing[key].solo.netRate) ? '' : _this.props.pricing[key].solo.netRate));
                    case 8:
                      soloNetRateError = _context2.sent;
                      _context2.next = 11;
                      return Services.validateInput('checkEmpty', "".concat(isNaN(_this.props.pricing[key].duo.netRate) ? '' : _this.props.pricing[key].duo.netRate));
                    case 11:
                      duoNetRateError = _context2.sent;
                      _context2.next = 14;
                      return Services.validateInput('checkEmpty', "".concat(isNaN(_this.props.pricing[key].family.netRate) ? '' : _this.props.pricing[key].family.netRate));
                    case 14:
                      familyNetRateError = _context2.sent;
                      _context2.next = 17;
                      return Services.validateInput('checkEmpty', "".concat(_this.props.pricing[key].carrier || ''));
                    case 17:
                      carrierError = _context2.sent;
                      if (markupError || soloNetRateError || duoNetRateError || familyNetRateError || carrierError) {
                        isValid = false;
                      }
                      _this.setState({
                        errors: _objectSpread(_objectSpread({}, _this.state.errors), {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "".concat(key, "markupError"), markupError), "".concat(key, "soloNetRateError"), soloNetRateError), "".concat(key, "duoNetRateError"), duoNetRateError), "".concat(key, "familyNetRateError"), familyNetRateError), "".concat(key, "carrierError"), carrierError))
                      });
                      return _context2.abrupt("return", null);
                    case 21:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x) {
                return _ref3.apply(this, arguments);
              };
            }());
            _context3.next = 10;
            return Promise.all(promises);
          case 10:
            return _context3.abrupt("return", isValid);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._setDefaultPrices = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var planDesign, pricing, promises;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            planDesign = _this.props.designs[_this.props.classID][_this.props.designID];
            pricing = _objectSpread({}, _this.props.pricing);
            promises = Object.keys(nameMap).map(function (key) {
              var coverage = planDesign[coverageKeyMap[key]];
              if (coverage && (!coverage.isSelected || !coverage[selectedKey[key]])) {
                pricing[key] = {
                  carrier: null,
                  markup: 10,
                  solo: {
                    netRate: 0,
                    netRateWithMarkup: 0,
                    commissionRate: 0,
                    grossRate: 0,
                    pastRates: {
                      grossRate: 0
                    }
                  },
                  duo: {
                    netRate: 0,
                    netRateWithMarkup: 0,
                    commissionRate: 0,
                    grossRate: 0,
                    pastRates: {
                      grossRate: 0
                    }
                  },
                  family: {
                    netRate: 0,
                    netRateWithMarkup: 0,
                    commissionRate: 0,
                    grossRate: 0,
                    pastRates: {
                      grossRate: 0
                    }
                  }
                };
              }
              return null;
            });
            _context4.next = 5;
            return Promise.all(promises);
          case 5:
            return _context4.abrupt("return", pricing);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._savePricing = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var isFormValid, data, success;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!_this.props.revision) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            window.scroll(0, 0);
            _context5.next = 5;
            return _this._validateForm();
          case 5:
            isFormValid = _context5.sent;
            if (isFormValid) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return", null);
          case 8:
            _context5.next = 10;
            return _this._setDefaultPrices();
          case 10:
            data = _context5.sent;
            _context5.next = 13;
            return _this.props.savePricing(_this.props.classID, _this.props.designID, data, dates.getUTC(_this.state.effectiveDate));
          case 13:
            success = _context5.sent;
            if (success) {
              _this.setState({
                effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
                showEffectiveDateDialog: false
              });
            }
            return _context5.abrupt("return", null);
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })), _this._toggleEffectiveDateDialog = function () {
      _this.setState({
        showEffectiveDateDialog: !_this.state.showEffectiveDateDialog
      });
    }, _this._setDefaults = function () {
      var planDesign = _this.props.designs[_this.props.classID][_this.props.designID];
      var pricing = _this.props.pricing;
      Object.keys(nameMap).map(function (key) {
        var coverage = planDesign[coverageKeyMap[key]];
        if (coverage && (!coverage.isSelected || !coverage[selectedKey[key]])) {
          return null;
        }
        if (process.env.NODE_ENV === 'development') {
          _this._onBlur(pricing[key].markup, key, 'solo', 'netRate', pricing[key] && pricing[key].solo.netRate !== 0 ? pricing[key].solo.netRate : 1);
          _this._onBlur(pricing[key].markup, key, 'duo', 'netRate', pricing[key] && pricing[key].solo.netRate !== 0 ? pricing[key].solo.netRate : 2);
          _this._onBlur(pricing[key].markup, key, 'family', 'netRate', pricing[key] && pricing[key].solo.netRate !== 0 ? pricing[key].solo.netRate : 3);
          _this._handleDropDownChange(key, 'carrier', pricing[key].carrier || 'Allstate');
        } else {
          _this._onBlur(pricing[key].markup, key, 'solo', 'netRate', !pricing[key] || pricing[key].solo.netRate === null ? '' : pricing[key].solo.netRate);
          _this._onBlur(pricing[key].markup, key, 'duo', 'netRate', !pricing[key] || pricing[key].duo.netRate === null ? '' : pricing[key].duo.netRate);
          _this._onBlur(pricing[key].markup, key, 'family', 'netRate', !pricing[key] || pricing[key].family.netRate === null ? '' : pricing[key].family.netRate);
        }
        return true;
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(PricingDesignForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.revision) {
        return null;
      }

      // set all the fields dynamically using the commission rates so they do not have to blur each field to get the new gross rates after a commission change
      this._setDefaults();
      return true;
    }

    /**
     * When a field is blurred, calculate the new rates and store in global state
     * @param markup
     * @param benefit
     * @param coverageType
     * @param key
     * @param value
     * @private
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var pricing = this.props.pricing;
      var planDesign = this.props.designs[this.props.classID][this.props.designID];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Object.keys(nameMap).map(function (key) {
        var coverage = planDesign[coverageKeyMap[key]];
        if (coverage && (!coverage.isSelected || !coverage[selectedKey[key]])) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: key
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          color: Theme.colors.darkBlue,
          medium: true,
          bold: true,
          display: "block",
          align: "left",
          margin: "20px 0 0 0"
        }, nameMap[key]), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: 50
          }
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          direction: "row",
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
          label: "Carrier",
          fullWidth: true,
          required: true,
          select: true,
          variant: "outlined",
          selectOptions: ['Sunlife', 'Simply Benefits', 'La Capitale', 'Equitable Life', 'Empire', 'Orion', 'SSQ', 'HumanaCare', 'AIG', 'Allstate', 'ASO', 'Maple', 'Gotodoctor', 'Dialogue', 'Camden', 'Fenchurch', 'Wawanesa', 'Desjardins', 'Industrial Alliance'].sort(),
          error: _this2.state.errors["".concat(key, "carrierError")],
          value: !pricing[key] || !pricing[key].carrier ? '' : pricing[key].carrier,
          onChange: function onChange(e) {
            return _this2._handleDropDownChange(key, 'carrier', e.target.value);
          }
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Markup",
          fullWidth: true,
          variant: "outlined",
          suffix: "%",
          decimalPlaces: 3,
          value: !pricing[key] || pricing[key].markup === null ? '' : pricing[key].markup,
          onBlur: function onBlur(e) {
            return _this2._onBlur(pricing[key].markup, key, null, 'markup', e.target.value);
          },
          error: _this2.state.errors["".concat(key, "markupError")]
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Commission Percentage",
          fullWidth: true,
          value: _this2.props.commissions[commissionMap[key]],
          variant: "outlined",
          suffix: "% ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Solo (Net Rate)",
          fullWidth: true,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          value: !pricing[key] || pricing[key].solo.netRate === null ? '' : pricing[key].solo.netRate,
          onBlur: function onBlur(e) {
            return _this2._onBlur(pricing[key].markup, key, 'solo', 'netRate', e.target.value);
          },
          error: _this2.state.errors["".concat(key, "soloNetRateError")]
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Solo (Commission Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].solo.commissionRate === null ? '' : pricing[key].solo.commissionRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Solo (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].solo.grossRate === null ? '' : pricing[key].solo.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Duo (Net Rate)",
          fullWidth: true,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          value: !pricing[key] || pricing[key].duo.netRate === null ? '' : pricing[key].duo.netRate,
          onBlur: function onBlur(e) {
            return _this2._onBlur(pricing[key].markup, key, 'duo', 'netRate', e.target.value);
          },
          error: _this2.state.errors["".concat(key, "duoNetRateError")]
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Duo (Commission Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].duo.commissionRate === null ? '' : pricing[key].duo.commissionRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Duo (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].duo.grossRate === null ? '' : pricing[key].duo.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Family (Net Rate)",
          fullWidth: true,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          value: !pricing[key] || pricing[key].family.netRate === null ? '' : pricing[key].family.netRate,
          onBlur: function onBlur(e) {
            return _this2._onBlur(pricing[key].markup, key, 'family', 'netRate', e.target.value);
          },
          error: _this2.state.errors["".concat(key, "familyNetRateError")]
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Family (Commission Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].family.commissionRate === null ? '' : pricing[key].family.commissionRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Family (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || pricing[key].family.grossRate === null ? '' : pricing[key].family.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: true
        }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          color: Theme.colors.darkBlue,
          medium: true,
          light: true,
          display: "block",
          align: "left",
          margin: "20px 0 0 0"
        }, "Enter any past rates from the Carrier to be used in the pricing breakdown summary."), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          container: true,
          direction: "row",
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Solo (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || !pricing[key].solo.pastRates ? '' : pricing[key].solo.pastRates.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: !_this2.props.showPastPricing,
          onBlur: function onBlur(e) {
            return _this2._setPastRate(key, 'solo', e.target.value);
          }
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Duo (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || !pricing[key].duo.pastRates ? '' : pricing[key].duo.pastRates.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: !_this2.props.showPastPricing,
          onBlur: function onBlur(e) {
            return _this2._setPastRate(key, 'duo', e.target.value);
          }
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 12,
          sm: 4
        }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
          label: "Family (Gross Rate)",
          fullWidth: true,
          value: !pricing[key] || !pricing[key].family.pastRates ? '' : pricing[key].family.pastRates.grossRate,
          variant: "outlined",
          prefix: "$ ",
          decimalPlaces: 3,
          disabled: !_this2.props.showPastPricing,
          onBlur: function onBlur(e) {
            return _this2._setPastRate(key, 'family', e.target.value);
          }
        })))));
      }), !this.props.revision && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          if (!_this2.props.isQuote && !_this2.props.isRevision) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._savePricing();
          }
        },
        color: "primary",
        marginTop: "40px",
        marginBottom: "40px"
      }, "Save Pricing For Design")), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showEffectiveDateDialog,
        close: this._toggleEffectiveDateDialog,
        title: "Set Effective Date",
        onSave: this._savePricing,
        saveButtonText: "Submit"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, "Please provide the date you would like the change(s) to be effective:"), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: "Effective Date",
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          _this2.setState({
            effectiveDate: e.target.value
          });
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, "By clicking Submit below, the changes made will be applied and effective on the date provided above. Back dated changes will have adjustments applied using current rates."), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })));
    }
  }]);
  return PricingDesignForm;
}(_react.PureComponent);
var _default = exports["default"] = PricingDesignForm;